import { render, staticRenderFns } from "./card-branch.vue?vue&type=template&id=210a4b7f&scoped=true"
import script from "./card-branch.vue?vue&type=script&lang=js"
export * from "./card-branch.vue?vue&type=script&lang=js"
import style0 from "./card-branch.vue?vue&type=style&index=0&id=210a4b7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210a4b7f",
  null
  
)

export default component.exports